<template>
  <div :class="cssClasses">
    <icon
      :name="iconName"
      size="xs"
      primaryColor="color-light" />

    <slot />
  </div>
</template>

<script>
export default {
  name: 'message',
  props: {
    'type': {
      default: 'info',
      type: String
    }
  },
  computed: {
    cssClasses () {
      return {
        'message': true,
        'is-info': this.type === 'info',
        'is-warning': this.type === 'warning',
        'is-success': this.type === 'success',
        'is-error': this.type === 'error'
      };
    },
    iconName () {
      if (this.type === 'error') {
        return 'cross-circle';
      }

      return 'info-circle';
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.message {
  border-radius: $border-radius-small;
  color: $color-light;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.4;
  margin: 0 auto 2rem auto;
  max-width: 1400px;
  padding: .7rem 1.4rem .7rem 3.6rem;
  position: relative;

  &.is-info {
    background: $color-notice;
  }

  &.is-warning {
    background: $color-warning;
  }

  &.is-error {
    background: $color-danger;
  }

  &.is-success {
    background: $color-success;
  }

  & > svg {
    left: 1rem;
    opacity: .75;
    position: absolute;
    top: 1rem;
  }

  a,
  & /deep/ a {
    color: $color-light;
    text-decoration: underline;

    &:active,
    &:focus,
    &:hover {
      opacity: .75;
    }
  }
}

@media (max-width: 1480px) {
  .message {
    margin: 0 auto 2rem auto;
    max-width: calc(100% - 4rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Message.vue